import React, { Fragment } from 'react'
import styled from 'styled-components'
import formatNumber from './helpers/formatNumber'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #eeeeee;
`
const Header = styled.h3`
  margin-top: 20px;
`
const LoanHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-weight: bold;
  padding: 8px;
  border-bottom: 9px solid #f8f8f8;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  &:nth-of-type(odd) {
    background: #EEEEEE;
  }
`
const Footer = styled.div`
  background: #40bac9;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-weight: bold;
  color: white;
  border-top: 9px solid #f8f8f8;
`
const Value = styled.div`
  padding: 8px;
`

export default class LoanPayments extends React.Component {
  generateRow = ({ scheduledMonthlyPayment, name }, jointAccountAmount) => {
    const monthlyJointAccountAmount = parseInt(jointAccountAmount / 12, 10)

    const monthlyAmount = scheduledMonthlyPayment - monthlyJointAccountAmount
    const yearlyAmount = (scheduledMonthlyPayment * 12) - jointAccountAmount

    return (
      <Row>
        <Value>{name}'s Individual Accounts</Value>
        <Value>{formatNumber(monthlyAmount)}</Value>
        <Value>{formatNumber(yearlyAmount)}</Value>
      </Row>
    )

  }
  renderGuarantor = () => {
    const { guarantor } = this.props
    const { jointAccountAmount } = guarantor

    return this.generateRow(guarantor, jointAccountAmount)
  }

  renderSpouse = () => {
    const { guarantor, spouse } = this.props
    const { jointAccountAmount } = guarantor

    if (!spouse) {
      return
    }

    return this.generateRow(spouse, jointAccountAmount)
  }

  renderTotalDebt = () => {
    const { guarantor, lastTaxYear, spouse } = this.props

    const scheduledPayment = guarantor.cashflowData.find(datum => datum.category === 'scheduled_yearly_payments' && datum.year === lastTaxYear)
    const housingPayment = guarantor.cashflowData.find(datum => datum.category === 'housing_yearly_payments' && datum.year === lastTaxYear)

    const scheduledYearlyPayments = scheduledPayment ? scheduledPayment.data : 0
    const housingYearlyPayments = housingPayment ? housingPayment.data : 0

    let totalAnnual = scheduledYearlyPayments + housingYearlyPayments

    const monthlyHousing = parseInt(housingYearlyPayments / 12, 10)
    const monthlyScheduled = parseInt(scheduledYearlyPayments / 12, 10)

    let totalMonthly = monthlyHousing + monthlyScheduled

    if(spouse){
      totalMonthly += spouse.scheduledMonthlyPayment
      totalMonthly -= parseInt(guarantor.jointAccountAmount / 12, 10)

      totalAnnual += (spouse.scheduledMonthlyPayment * 12)
      totalAnnual -= parseInt(guarantor.jointAccountAmount, 10)
    }

    return(
      <Footer>
        <Value>Total Debt</Value>
        <Value>{formatNumber(totalMonthly)}</Value>
        <Value>{formatNumber(totalAnnual)}</Value>
      </Footer>
    )
  }

  renderHousingPayment = () => {
    const { guarantor, lastTaxYear } = this.props

    const housingPaymentDatum = guarantor.cashflowData.find(datum => datum.category === 'housing_yearly_payments' && datum.year === lastTaxYear)

    const housingPayment = housingPaymentDatum ? housingPaymentDatum.data : 0
    const monthlyHousing = formatNumber(parseInt(housingPayment / 12, 10))

    return(
      <Row>
        <Value>Housing Payment</Value>
        <Value>{monthlyHousing}</Value>
        <Value>{formatNumber(housingPayment)}</Value>
      </Row>
    )
  }

  renderJointAmount = () => {
    const { spouse, lastTaxYear, guarantor } = this.props

    if (!spouse) {
      return null
    }

    const jointAccountAmount = guarantor.jointAccountAmount
    const monthlyJointAccountAmount = formatNumber(parseInt(jointAccountAmount / 12, 10))

    return(
      <Row>
        <Value>Joint Accounts</Value>
        <Value>{monthlyJointAccountAmount}</Value>
        <Value>{formatNumber(jointAccountAmount)}</Value>
      </Row>
    )
  }
  renderCreditData = () => {
    const { spouse, guarantor } = this.props

    let creditDataUrls
    if (this.props.spouse) {
      creditDataUrls = [
        {
          creditDataUrls: guarantor.creditDataUrls,
          name: guarantor.name
        },
        {
          creditDataUrls: spouse.creditDataUrls,
          name: spouse.name
        }
      ]
    } else {
      creditDataUrls = [{
        creditDataUrls: guarantor.creditDataUrls,
        name: guarantor.name
      }]
    }

    return creditDataUrls.map((g,i) => {
      return (
        <Fragment key={g.name + i}>
          <div>
            {g.creditDataUrls[0] && <a target="_blank" href={g.creditDataUrls[0]}>View {g.name}'s credit data soft pull</a>}
          </div>
          <div>
            {g.creditDataUrls[1] && <a target="_blank" href={g.creditDataUrls[1]}>View {g.name}'s credit data</a>}
          </div>
        </Fragment>
      )
    })
  }
  render() {
    const { name } = this.props
    return (
      <section>
        <Header>Loan Payments for {name}</Header>
        <Container>
          <LoanHeader>
            <div />
            <b>Monthly Payment</b>
            <b>Annual Payments</b>
          </LoanHeader>
          <Fragment>
            { this.renderGuarantor() }
            { this.renderSpouse() }
            { this.renderJointAmount() }
            { this.renderHousingPayment() }
            { this.renderTotalDebt() }
          </Fragment>
        </Container>
        { this.renderCreditData() }
      </section>
    )
  }
}
